import React, { FC, PropsWithChildren } from 'react';

import { CirclePlaceholder } from 'app/components/circle-placeholder';
import { ImageProps } from 'app/components/image';

import { StyledInformationStep, StyledIconContainer, StyledIcon, StyledContent } from './base-information-step.styled';

export interface BaseInformationStepProps {
    icon: ImageProps;
    loading?: boolean;
}

export const BaseInformationStep: FC<PropsWithChildren<BaseInformationStepProps>> = (props) => {
    const { icon, children, loading } = props;

    return (
        <StyledInformationStep>
            <StyledIconContainer $loading={loading}>
                {loading ? <CirclePlaceholder /> : <StyledIcon {...icon} />}
            </StyledIconContainer>
            <StyledContent>{children}</StyledContent>
        </StyledInformationStep>
    );
};
